var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5 4.5L12.8993 13.5097C12.8468 14.2987 12.8204 14.6933 12.65 14.9925C12.4999 15.2559 12.2736 15.4676 12.0008 15.5999C11.691 15.75 11.2955 15.75 10.5046 15.75H7.49533C6.70445 15.75 6.30901 15.75 5.99917 15.5999C5.72638 15.4676 5.50004 15.2559 5.34999 14.9925C5.17955 14.6933 5.15325 14.2987 5.10064 13.5097L4.5 4.5M3 4.5H15M12 4.5L11.797 3.89105C11.6003 3.30094 11.5019 3.00588 11.3195 2.78773C11.1584 2.5951 10.9516 2.44599 10.7179 2.35409C10.4532 2.25 10.1422 2.25 9.5202 2.25H8.4798C7.85775 2.25 7.5468 2.25 7.28213 2.35409C7.04844 2.44599 6.84156 2.5951 6.68047 2.78773C6.49804 3.00588 6.39969 3.30094 6.20298 3.89105L6 4.5M10.5 7.5V12.75M7.5 7.5V12.75",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.b0e5b32347d5d11fdd04d59435b15d53.svg";
export { ForwardRef as ReactComponent };